import initCollection from '@sectionsJS/collection';
import initRecentlyViewedProducts from '@sectionsJS/recently-viewed-products';
import { initScrollRestore } from '@sectionsJS/collection/scrollRestore';

// RUN ASAP: start listening before the grid is built, so a back navigation is caught on the
// first render instead of after initCollection() has awaited Nosto
initScrollRestore();

$(async () => {
  await initCollection();
  initRecentlyViewedProducts();
});
